export const optionHeight = {
  groupHeading: 36,
  user: 40,
  userDescription: 56,
  tag: 46,
  tagDescription: 56,
  basic: 32,
  allOptions: 56,
};
